// The generated API client, made once per portal and handed down by context (spec/08 §1.1: the only
// HTTP client the portal uses). Tests hand in one built on a fake `fetch`.

import { createApiClient, type ApiClient, type FetchLike } from '@clavian/api-client';
import { createContext, useContext, type ReactNode } from 'react';

export interface PlayerApiOptions {
  /** Defaults to `VITE_CLAVIAN_API_URL`, then the portal's own origin (where `/v1` is proxied). */
  readonly baseUrl?: string;
  readonly fetch?: FetchLike;
}

export function createPlayerApi(options: PlayerApiOptions = {}): ApiClient {
  return createApiClient({
    baseUrl: options.baseUrl ?? import.meta.env.VITE_CLAVIAN_API_URL ?? '',
    // The portal authenticates with better-auth's session cookie, never a bearer token (spec/08 §2.2).
    credentials: 'include',
    ...(options.fetch === undefined ? {} : { fetch: options.fetch }),
  });
}

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({ api, children }: { readonly api: ApiClient; readonly children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const api = useContext(ApiContext);
  if (api === null) throw new Error('useApi() needs an <ApiProvider> above it.');
  return api;
}
